import {useSiteLanguage} from "../career/SiteLanguage";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import "../styles/Anket.css";

const Anket = () => {
  const {tx} = useSiteLanguage();
    const { modulEgitimAnketId } = useParams();
    const location = useLocation();
    const navigate = useNavigate();

    const token = localStorage.getItem("token");
    const apiBase = process.env.REACT_APP_API_BASE_URL;

    const gelenState =
        location.state ||
        JSON.parse(
            sessionStorage.getItem(`anketState_${modulEgitimAnketId}`) || "null"
        );

    const [anketState] = useState(gelenState);
    const fromEgitim = anketState?.fromEgitim === true;
    const [aktifSiraNo, setAktifSiraNo] = useState(gelenState?.ilkSiraNo || 1);
    const [soru, setSoru] = useState(null);
    const [seciliSecenekId, setSeciliSecenekId] = useState(null);
    const [seciliSecenekIds, setSeciliSecenekIds] = useState([]);
    const [cevapMetni, setCevapMetni] = useState("");
    const [loading, setLoading] = useState(false);
    const [kayitLoading, setKayitLoading] = useState(false);
    const [hata, setHata] = useState("");
    const [sonuc, setSonuc] = useState(null);
    const [showCikisPopup, setShowCikisPopup] = useState(false);

    const soruGetir = async (siraNo) => {
        try {
            setLoading(true);
            setHata("");

            const res = await axios.get(
                `${apiBase}/api/KullaniciEgitimAnket/detay/${modulEgitimAnketId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            const sorular = res.data?.sorular?.$values || [];
            const bulunanSoru = sorular.find(
                (x) => Number(x.siraNo) === Number(siraNo)
            );

            if (!bulunanSoru) {
                setHata("Soru bulunamadı.");
                return;
            }

            setSoru({
                ...bulunanSoru,
                toplamSoru: res.data?.toplamSoru || sorular.length,
                oncekiSiraNo: siraNo > 1 ? siraNo - 1 : null,
                sonrakiSiraNo: siraNo < sorular.length ? siraNo + 1 : null,
            });

            setSeciliSecenekId(null);
            setSeciliSecenekIds([]);
            setCevapMetni("");
        } catch (err) {
            console.error("Anket detayı getirilemedi:", err);
            setHata("Soru yüklenirken bir sorun oluştu.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (modulEgitimAnketId) {
            soruGetir(aktifSiraNo);
        }
    }, [modulEgitimAnketId, aktifSiraNo]);

    const soruId =
        soru?.modulEgitimAnketSoruId ||
        soru?.soruId ||
        soru?.id;

    const soruMetni =
        soru?.soruMetni ||
        soru?.metin ||
        soru?.baslik ||
        "";

    const soruTipi =
        soru?.soruTipi ||
        soru?.tip ||
        soru?.soruTipiAdi ||
        "";

    const soruTipiKey = String(soruTipi || "").toLowerCase();

    const evetHayirMi = soruTipiKey === "evethayir";
    const puanMi = soruTipiKey === "puan";
    const metinMi = soruTipiKey === "metin";
    const cokluSecimMi = soruTipiKey === "coklusecim";
    const tekSecimMi = soruTipiKey === "teksecim";

    const apiSecenekler =
        soru?.secenekler?.$values ||
        soru?.secenekler ||
        [];

    const secenekler = evetHayirMi
        ? apiSecenekler.length > 0
            ? apiSecenekler
            : [
                { id: "evet", secenekMetni: "Evet", frontendValue: "Evet" },
                { id: "hayir", secenekMetni: "Hayır", frontendValue: "Hayır" },
            ]
        : puanMi
            ? [1, 2, 3, 4, 5].map((puan) => ({
                id: `puan-${puan}`,
                secenekMetni: String(puan),
                frontendValue: String(puan),
            }))
            : cokluSecimMi || tekSecimMi
                ? apiSecenekler
                : [];

    const zorunluMu =
        soru?.zorunluMu === true ||
        soru?.zorunlu === true;

    const oncekiSiraNo =
        soru?.oncekiSiraNo ||
        soru?.oncekiSoruNo ||
        null;

    const sonrakiSiraNo =
        soru?.sonrakiSiraNo ||
        soru?.sonrakiSoruNo ||
        null;

    const toplamSoru =
        anketState?.toplamSoru ||
        soru?.toplamSoru ||
        0;

    const handleCokluSecimToggle = (secenekId) => {
        setSeciliSecenekIds((prev) => {
            if (prev.includes(secenekId)) {
                return prev.filter((id) => id !== secenekId);
            }

            return [...prev, secenekId];
        });
    };

    const cevapKaydet = async () => {
        if (!soruId) return false;

        const frontendCevapMi = puanMi;
        const acikUcluMu = metinMi;

        if (zorunluMu) {
            if (cokluSecimMi && seciliSecenekIds.length === 0) {
                setHata("Bu soru zorunludur. Lütfen en az bir seçenek seçiniz.");
                return false;
            }

            if (!cokluSecimMi && !acikUcluMu && !seciliSecenekId) {
                setHata("Bu soru zorunludur. Lütfen bir seçenek seçiniz.");
                return false;
            }
        }

        try {
            setKayitLoading(true);
            setHata("");

            if (cokluSecimMi) {
                for (const secenekId of seciliSecenekIds) {
                    await axios.post(
                        `${apiBase}/api/KullaniciEgitimAnket/cevapkaydet`,
                        {
                            modulEgitimKullaniciSurecId: anketState?.surecId || null,
                            modulEgitimAnketId: Number(modulEgitimAnketId),
                            modulEgitimAnketSoruId: soruId,
                            modulEgitimAnketSecenekId: secenekId,
                            cevapMetni: null,
                        },
                        {
                            headers: {
                                Authorization: `Bearer ${token}`,
                            },
                        }
                    );
                }
            } else {
                await axios.post(
                    `${apiBase}/api/KullaniciEgitimAnket/cevapkaydet`,
                    {
                        modulEgitimKullaniciSurecId: anketState?.surecId || null,
                        modulEgitimAnketId: Number(modulEgitimAnketId),
                        modulEgitimAnketSoruId: soruId,
                        modulEgitimAnketSecenekId:
                            frontendCevapMi || acikUcluMu
                                ? null
                                : typeof seciliSecenekId === "number"
                                    ? seciliSecenekId
                                    : null,
                        cevapMetni:
                            frontendCevapMi || typeof seciliSecenekId === "string"
                                ? seciliSecenekId
                                : acikUcluMu
                                    ? cevapMetni
                                    : null,
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
            }

            return true;
        } catch (err) {
            console.error("Anket cevabı kaydedilemedi:", err);
            setHata("Cevap kaydedilirken bir sorun oluştu.");
            return false;
        } finally {
            setKayitLoading(false);
        }
    };

    const sonrakiSoruyaGec = async () => {
        const kaydedildi = await cevapKaydet();
        if (!kaydedildi) return;

        if (sonrakiSiraNo) {
            setAktifSiraNo(sonrakiSiraNo);
        } else if (aktifSiraNo < toplamSoru) {
            setAktifSiraNo((prev) => prev + 1);
        }
    };

    const oncekiSoruyaGec = () => {
        if (oncekiSiraNo) {
            setAktifSiraNo(oncekiSiraNo);
        } else if (aktifSiraNo > 1) {
            setAktifSiraNo((prev) => prev - 1);
        }
    };

    const anketiBitir = async () => {
        const kaydedildi = await cevapKaydet();
        if (!kaydedildi) return;

        try {
            setKayitLoading(true);
            setHata("");

            const res = await axios.post(
                `${apiBase}/api/KullaniciEgitimAnket/bitir`,
                {
                    modulEgitimKullaniciSurecId: anketState?.surecId || null,
                    modulEgitimAnketId: Number(modulEgitimAnketId),
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (fromEgitim) {
                navigate(`/personel/egitim/${anketState.egitimId}`, {
                    state: {
                        aktifSayfaId: anketState.aktifSayfaId,
                        egitim: {
                            egitimId: anketState.egitimId,
                            surecId: anketState.surecId,
                            aktifSayfaId: anketState.aktifSayfaId,
                        },
                        geriDonenAnket: true,
                        tamamlananIcerikId: anketState.icerikId,
                    },
                });

                return;
            }

            if (anketState?.fromProfilAnket) {
                navigate("/profil", {
                    replace: true,
                    state: {
                        aktifMenu: "anketlerim",
                    },
                });

                return;
            }

            setSonuc(res.data);
        } catch (err) {
            console.error("Anket bitirilemedi:", err);

            const mesaj =
                err.response?.data?.message ||
                err.response?.data?.mesaj ||
                "Anket tamamlanırken bir sorun oluştu.";

            setHata(mesaj);
        } finally {
            setKayitLoading(false);
        }
    };

    const handleCikisYap = async () => {
        try {
            await axios.post(
                `${apiBase}/api/KullaniciEgitimAnket/bitir`,
                {
                    modulEgitimKullaniciSurecId: anketState?.surecId || null,
                    modulEgitimAnketId: Number(modulEgitimAnketId),
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
        } catch (err) {
            console.error("Çıkış sırasında anket bitirilemedi:", err);
        } finally {
            if (fromEgitim) {
                navigate(`/personel/egitim/${anketState.egitimId}`, {
                    state: {
                        aktifSayfaId: anketState.aktifSayfaId,
                        egitim: {
                            egitimId: anketState.egitimId,
                            surecId: anketState.surecId,
                            aktifSayfaId: anketState.aktifSayfaId,
                        },
                    },
                });
            } else {
                navigate("/profil");
            }

        }
    };

    return (
        <div className="anket-page">
            <div className="anket-container">
                <div className="anket-hero">
                    <div className="anket-hero-left">
                        <img src="/images/fulla.png" alt="Fulla Moda" />

                        <div>
                            <span className="anket-hero-label">{tx("ANKET")}</span>
                            <h2>{anketState?.baslik || "Anket"}</h2>
                            <p>{tx("Soru")}{aktifSiraNo}
                                {toplamSoru ? ` / ${toplamSoru}` : ""}{tx("• Görüşleriniz bizim için değerli")}</p>
                        </div>
                    </div>

                    <button
                        className="anket-cikis-btn"
                        onClick={() => setShowCikisPopup(true)}
                    >{tx("Çık")}</button>
                </div>

                {loading && <div className="anket-card">{tx("Soru yükleniyor...")}</div>}

                {!loading && hata && (
                    <div className="anket-hata-box">{hata}</div>
                )}

                {!loading && soru && (
                    <div className="anket-layout">

                        <div className="anket-soru-nav">
                            <h4>{tx("Sorular")}</h4>

                            {Array.from({ length: toplamSoru }, (_, i) => (
                                <button
                                    key={i}
                                    className={`anket-soru-btn ${aktifSiraNo === i + 1 ? "aktif" : ""
                                        }`}
                                    onClick={() => setAktifSiraNo(i + 1)}
                                >
                                    {i + 1}
                                </button>
                            ))}
                        </div>

                        <div className="anket-card">
                            <div className="anket-soru-header">
                                <span className="anket-soru-no">{tx("Soru")}{aktifSiraNo}</span>
                                {zorunluMu && <span className="anket-zorunlu">{tx("Zorunlu")}</span>}
                            </div>

                            <h3>{soruMetni}</h3>

                            {metinMi ? (
                                <textarea
                                    className="anket-textarea"
                                    value={cevapMetni}
                                    onChange={(e) => setCevapMetni(e.target.value)}
                                    placeholder={tx("Cevabınızı yazınız...")}
                                />
                            ) : (
                                <div
                                    className={`anket-secenek-listesi ${puanMi ? "puan-listesi" : ""
                                        }`}
                                >
                                    {secenekler.map((secenek) => {
                                        const secenekId =
                                            secenek.modulEgitimAnketSecenekId ||
                                            secenek.secenekId ||
                                            secenek.id ||
                                            secenek.frontendValue;

                                        const secenekMetni =
                                            secenek.secenekMetni ||
                                            secenek.metin ||
                                            secenek.cevapMetni ||
                                            secenek.baslik;

                                        return (
                                            <label
                                                className={`anket-secenek ${seciliSecenekId === secenekId ? "secili" : ""
                                                    } ${puanMi ? "puan-secenek" : ""}`}
                                                key={secenekId}
                                            >
                                                <input
                                                    type={cokluSecimMi ? "checkbox" : "radio"}
                                                    name={cokluSecimMi ? `anketSecenek-${soruId}` : "anketSecenek"}
                                                    checked={
                                                        cokluSecimMi
                                                            ? seciliSecenekIds.includes(secenekId)
                                                            : seciliSecenekId === secenekId
                                                    }
                                                    onChange={() => {
                                                        if (cokluSecimMi) {
                                                            handleCokluSecimToggle(secenekId);
                                                        } else {
                                                            setSeciliSecenekId(secenekId);
                                                        }
                                                    }}
                                                />
                                                <span>{secenekMetni}</span>
                                            </label>
                                        );
                                    })}
                                </div>
                            )}

                            <div className="anket-actions">
                                <button
                                    className="anket-secondary-btn"
                                    onClick={oncekiSoruyaGec}
                                    disabled={aktifSiraNo <= 1 || kayitLoading}
                                >{tx("Önceki")}</button>

                                {aktifSiraNo < toplamSoru || sonrakiSiraNo ? (
                                    <button
                                        className="anket-primary-btn"
                                        onClick={sonrakiSoruyaGec}
                                        disabled={kayitLoading}
                                    >
                                        {kayitLoading ? "Kaydediliyor..." : tx("Sonraki")}
                                    </button>
                                ) : (
                                    <button
                                        className="anket-primary-btn"
                                        onClick={anketiBitir}
                                        disabled={kayitLoading}
                                    >
                                        {kayitLoading ? "Tamamlanıyor..." : "Anketi Bitir"}
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {sonuc && (
                <div className="anket-sonuc-overlay">
                    <div className="anket-sonuc-popup">
                        <h2>{tx("Anket Tamamlandı")}</h2>
                        <p>{tx("Katılımınız için teşekkür ederiz.")}</p>
                        <button onClick={() => navigate("/profil")}>{tx("Profile Dön")}</button>
                    </div>
                </div>
            )}

            {showCikisPopup && (
                <div className="anket-sonuc-overlay">
                    <div className="anket-cikis-popup">
                        <h3>{tx("Anketten çıkmak istiyor musunuz?")}</h3>

                        <p>{tx("Çıkış yaptığınızda anket sonlandırılacaktır.")}</p>

                        <div className="anket-cikis-actions">
                            <button
                                className="anket-cikis-onay"
                                onClick={handleCikisYap}
                            >{tx("Evet Çık")}</button>
                            <button
                                className="anket-cikis-iptal"
                                onClick={() => setShowCikisPopup(false)}
                            >{tx("Vazgeç")}</button>
                        </div>
                    </div>
                </div>
            )}


        </div>
    );
};

export default Anket;
